var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoltarTopo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "voltar_topo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Mobile_Home_Escuro",
    transform: "translate(-344.000000, -2163.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 1997.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "voltar_topo",
    transform: "translate(345.000000, 167.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,9.1 C26,2.6 23.4,0 16.9,0 L9.1,0 C2.6,0 0,2.6 0,9.1 L0,16.9 C0,23.4 2.6,26 9.1,26 L16.9,26 C23.4,26 26,23.4 26,16.9 L26,9.1 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2390381,15.6 L13.0390381,10.4 L7.83903809,15.6",
    id: "Vector"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltarTopo);
export default __webpack_public_path__ + "static/media/voltar_topo.a8f10caabd372d35ebf27357840b10c6.svg";
export { ForwardRef as ReactComponent };